import React, { useEffect } from "react";
import { useState } from "react";
import { FaXmark } from "react-icons/fa6";
import {
  useGetJoiningTablesMutation,
  useUpdateBaseTableMutation,
} from "./JoinTableApiSlice";
import { useSearchParams } from "react-router-dom";

export default function ChangeBaseTableModal({
  closeModal,
  baseDatabaseName,
  databaseId,
}) {
  // console.log(baseDatabaseName);

  const [allTables, setAllTables] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedTable, setSelectedTable] = useState(null);
  const [message, setMessage] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  // Fetch the tables
  const [
    getTables,
    {
      data: tablesData,
      isError: isTablesError,
      isLoading: isTablesLoading,
      isSuccess: isTablesSuccess,
      error: tablesError,
    },
  ] = useGetJoiningTablesMutation();
  // update base table
  const [
    updateBaseTable,
    {
      data: baseTableData,
      isError: isBaseTableError,
      isLoading: isBaseTableLoading,
      isSuccess: isBaseTableSuccess,
      error: baseTableError,
    },
  ] = useUpdateBaseTableMutation();

  useEffect(() => {
    if (baseDatabaseName) {
      const object = { dataSourceId: databaseId };
      getTables(object);
    }
  }, []);

  useEffect(() => {
    if (
      tablesData &&
      tablesData["response"] &&
      tablesData["response"]["tables"]
    ) {
      if (tablesData?.["response"]?.["tables"]) {
        setAllTables(tablesData?.["response"]?.["tables"]);
      } else {
        console.error("schemaTable is not defined");
      }
    }
  }, [isTablesSuccess]);

  const filteredOptions = allTables.filter((option) => {
    return option.toLowerCase().includes(searchTerm.toLowerCase());
  });
  const handleSearchTable = (e) => {
    setSearchTerm(e.target.value);
  };
  const handleUpdateBaseTable = async (databaseId, selectedTable) => {
    if (selectedTable === null) {
      setMessage("Please select a table.");
      return;
    }
    const updateBaseTableObject = {
      dataSourceId: databaseId,
      newTableName: selectedTable,
    };
    // console.log(updateBaseTableObject);

    try {
      const response = await updateBaseTable(updateBaseTableObject).unwrap();
      setMessage(response.message || "Upload successful.");
      const updateTableName = (newTableName) => {
        searchParams.set("table", newTableName);
        setSearchParams(searchParams, { replace: true });
      };
      if (response.message) {
        const timer = setTimeout(() => {
          const newTableName = response.newTableName;
          updateTableName(newTableName);
          closeModal();
        }, 1500);
        return () => clearTimeout(timer);
      }
    } catch (err) {
      setMessage(err?.data?.error || "Something went wrong during upload.");
    }
  };

  return (
    <main className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <section
        className={`flex flex-col bg-white shadow-2xl rounded w-full max-w-lg justify-between items-center gap-0`}
      >
        <header className="flex bg-gray-50 w-full p-2 items-center justify-between rounded-t-lg  font-medium">
          Change the base table
          <button onClick={closeModal}>
            <FaXmark />
          </button>
        </header>
        <div className="flex flex-col gap-2 justify-start items-start w-full p-2">
          <span className="font-medium">Tables :</span>
          <input
            autoComplete="off"
            type="search"
            name="query"
            placeholder="search tables..."
            onChange={handleSearchTable}
            className="px-3 w-full rounded py-[3px] border outline-none"
          />
          <div className="flex flex-col justify-start items-start w-full h-60 overflow-y-auto">
            {isTablesError ? (
              <div className="text-left font-medium text-red-500">
                {tablesError
                  ? tablesError?.data?.message
                  : "An error occured while loading the tables..."}
              </div>
            ) : null}
            {isTablesSuccess
              ? filteredOptions.map((item, index) => (
                  <button
                    onClick={() => setSelectedTable(item)}
                    className={`w-full flex items-center justify-start p-1 border-b rounded ${
                      selectedTable === item
                        ? "bg-blue-950 text-white"
                        : "hover:bg-gray-100"
                    }`}
                    key={index}
                  >
                    {item}
                  </button>
                ))
              : null}
          </div>
        </div>
        <footer className="flex justify-between items-center w-full p-2 bg-gray-50">
          <div className="text-sm text-left w-full">
            {isTablesLoading ? (
              <p className="text-yellow-500 font-medium">loading tables...</p>
            ) : null}
            {message && (
              <p
                className={`font-medium ${
                  isBaseTableSuccess ? "text-green-500" : "text-red-500"
                }`}
              >
                {message}
              </p>
            )}
          </div>
          <button
            className="border py-1 px-2 tracking-wide mr-2 text-gray-700 hover:bg-gray-200"
            onClick={closeModal}
          >
            Close
          </button>
          <button
            className={`border py-1 px-2 tracking-wide bg-blue-950 text-white`}
            onClick={() => handleUpdateBaseTable(databaseId, selectedTable)}
          >
            {isBaseTableLoading ? "Updating..." : "Update"}
          </button>
        </footer>
      </section>
    </main>
  );
}
